import React, { useEffect, useState } from "react";
import { GridColDef, GridToolbarFilterButton, GridRowId } from '@mui/x-data-grid-pro';
import { Box, Button, FormControl, Grid, IconButton, LinearProgress, TextField, Tooltip } from "@mui/material";
import useAuth from "../../context/AuthProvider";
import Swal from "sweetalert2";
import { RiExpandUpDownLine } from "react-icons/ri";
import { AddEditLicenseContact } from "../AddEdit/AddEditLicenseContact";
import { format } from 'date-fns';
import { apiClient } from "../../helper/api";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { writeXlsxFile, formatUtcToLocal } from "../../helper/utils";
import moment from "moment";
import { Search, Close, KeyboardArrowDown, KeyboardArrowUp, FileDownload, FileUpload, Add } from "@mui/icons-material";
import { Autocomplete } from "@mui/material";
import EditIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutline";
interface LicenseesContactInformation {
    partnerLincenseeInformationId: any;
    customerName: string;
    partnersId: any;
    postalAbbvs: string;
    licenseeName:string;
    pageSize: number;
    pageNumber: number;
    cancellationDate: any;
    entity: any;
    fein: any;
    licenseNumber: any;
    licenseState: any;
    licensee: any;
    mainLicensee: any;
    npn: any;
    title: any;
}

interface Iprops {
    onExportXlsx: (val: LicenseesContactInformation[]) => void
    licenseesContactArry: LicenseesContactInformation[];
    pageSize: number;
    totalCount: number;
    setPageSize: React.Dispatch<React.SetStateAction<number>>;
    pageNumber: number;
    setPageNumber: React.Dispatch<React.SetStateAction<number>>;
    setFilterModel: React.Dispatch<React.SetStateAction<any>>;
    setSortModel: React.Dispatch<React.SetStateAction<any>>;
    sortModel: any;
    selectedStateId: number;
    setSelectedStateId: React.Dispatch<React.SetStateAction<number>>;
    selectedLicenseeName: string;
    setSelectedLicenseeName: React.Dispatch<React.SetStateAction<string>>;
    selectedPartner: number;
    setSelectedPartner: React.Dispatch<React.SetStateAction<number>>;
    selectedRows: LicenseesContactInformation[];
    setSelectedRows: React.Dispatch<React.SetStateAction<LicenseesContactInformation[]>>;
    getLicenseMatrix: (pageSize: number, pageNumber: number) => Promise<any>;
    fetchLicenseMatrixData: (pageNumber: number, pageSize: number) => Promise<any>;
}

export const initialLBData: LicenseesContactInformation = {
    partnerLincenseeInformationId: 0,
    customerName: '',
    partnersId: 0,
    postalAbbvs: '',
    licenseeName:'',
    pageSize:50,
    pageNumber:1,
    cancellationDate: '',
    entity: false,
    fein: '',
    licenseNumber: '',
    licenseState: '',
    licensee: '',
    mainLicensee: false,
    npn: '',
    title: ''
}

export const LicenseMatrix: React.FC<Iprops> = ({
    licenseesContactArry,
    pageSize,
    setPageSize,
    pageNumber,
    setPageNumber,
    setFilterModel,
    totalCount,
    setSortModel,
    onExportXlsx,
    getLicenseMatrix,
    fetchLicenseMatrixData,
    selectedPartner,
    setSelectedPartner,
    selectedStateId,
    setSelectedStateId,
    selectedLicenseeName,
    setSelectedLicenseeName,
    sortModel,
}) => {
    const { user } = useAuth();
    const token = user?.token;
    const [selectedRowIds, setSelectedRowIds] = React.useState<GridRowId[]>([]);
    const [Open, setOpen] = React.useState(false);
    const [Formdata, setFormData] = React.useState(initialLBData);
    const [loading, setLoading] = useState(false);
    const initialUserdata = { partnersId: 0, customerName: "" };
    const [Partners, setPartners] = useState([initialUserdata]);
    const initialStatedata = { stateId: 0, stateName: '',  postalAbbv: ''}
    const [States, setStates] = useState([initialStatedata]);
    const initialLicenseedata = { licenseeId: 0, licenseeName: ''}
    const [licensees, setLicensees] = useState([initialLicenseedata]);
    const fileInputRef = React.useRef<HTMLInputElement>(null);
    const [invalidRecords, setInvalidRecords] = useState<any[]>([]);
    const pollIntervalRef = React.useRef<NodeJS.Timeout | null>(null);
    const progressSwalRef = React.useRef<any>(null);
    const isPollingRef = React.useRef<boolean>(false);
    const isBackgroundModeRef = React.useRef<boolean>(false);
    const currentJobIdRef = React.useRef<string | null>(null);
    const [filterClient, setFilterClient] = useState<number>(0);
    const [filterState, setFilterState] = useState<number>(0);
    const [filterLicensee, setFilterLicensee] = useState<string>('');

    const columns: GridColDef[] = [
        {
            field: 'id',
            flex: 0.7,
            minWidth: 100,
            headerName: "Action",
            align: 'center',
            headerAlign: 'center',
            disableColumnMenu: true,
            filterable: false,
            sortable: false,
            renderCell: (params) => (<div> 
                <IconButton
                    color="primary"
                    onClick={(e) => { e.stopPropagation(); handleEdit(params.row) }}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
                >
                    <Tooltip
                        title="Edit"
                        placement="top"
                        arrow
                    >
                        <EditIcon fontSize="small" color="primary" />
                    </Tooltip>
                </IconButton >
                {user?.userRoles.split(",").includes("Super Admin") ?
                    <IconButton
                        color="error"
                        onClick={(e) => { e.stopPropagation(); handleDelete(params.row.partnerLincenseeInformationId); }}
                        sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(211,48,47,0.15) !important' } }}
                    >
                        <Tooltip
                            title="Delete"
                            placement="top"
                            arrow
                        >
                            <DeleteOutlinedIcon fontSize="small" color="error" />
                        </Tooltip>
                    </IconButton>
                : ""}
            </div>)
        }, 
        {
            field: 'licensee',
            headerName: 'Licensee',
            type: 'text',
            flex: 3,              
            minWidth: 250,        
            align: 'left',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'licensee'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            renderCell: (params) => {
                const value = params.value || '';
                return (
                    <Tooltip title={value || ''} arrow placement="top" enterDelay={300}>
                        <span
                            style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                display: 'block',
                                width: '100%',
                                cursor: 'default',
                                textAlign: 'left'
                            }}
                        >
                            {value}
                        </span>
                    </Tooltip>
                );
            },
            headerAlign: 'left',
          },
        {
            field: 'licenseState',
            headerName: 'License State',
            type: 'text',
            flex: 1,
            minWidth: 165,
            align: 'left',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'licenseState'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            headerAlign: 'left'
        },
        {
            field: 'licenseNumber',
            headerName: 'License Number',
            type: 'text',
            flex: 2,
            minWidth: 180,
            align: 'left',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'licenseNumber'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            renderCell: (params) => {
                const value = params.value || '';
                return (
                    <Tooltip title={value || ''} arrow placement="top" enterDelay={300}>
                        <span 
                            style={{ 
                                overflow: 'hidden', 
                                textOverflow: 'ellipsis', 
                                whiteSpace: 'nowrap', 
                                display: 'block',
                                width: '100%',
                                textAlign: 'left'
                            }}
                        >
                            {value}
                        </span>
                    </Tooltip>
                );
            },
            headerAlign: 'left'
        },
        {
            field: 'PartnersName',
            headerName: 'Clients Name',
            type: 'text',
            flex: 3,              
            minWidth: 250,        
            align: 'left',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'PartnersName'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            renderCell: (params) => {
                const fullName = params.row.customerName || '';
                return (
                    <Tooltip title={fullName || ''} arrow placement="top" enterDelay={300}>
                        <span 
                            style={{
                                color: 'inherit',
                                textAlign: 'left',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: 'block',
                                width: '100%',
                                cursor: 'default'
                            }}
                        >
                            {fullName}
                        </span>
                    </Tooltip>
                );
            },
            valueGetter: (params) => {
                return Partners.find((item) => item.partnersId === params.row.partnersId)?.customerName || '';
            },
            headerAlign: 'left'
        },       
        {
            field: 'mainLicensee',
            headerName: 'Main Licensee',
            type: 'text',
            flex: 1.2,
            minWidth: 150,
            align: 'left',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'mainLicensee'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            headerAlign: 'left'
        },
        {
            field: 'entity',
            headerName: 'Entity',
            type: 'text',
            flex: 1,
            minWidth: 110,
            align: 'left',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'entity'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            headerAlign: 'left'
        },
        {
            field: 'npn',
            headerName: 'NPN',
            type: 'text',
            flex: 1.5,
            minWidth: 140,
            align: 'left',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'npn'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            renderCell: (params) => {
                if (!params.value) {
                    return <span style={{ color: 'inherit', textAlign: 'left', display: 'block', width: '100%' }}>{params.value}</span>;
                }
                
                // Handle scientific notation conversion
                let npnValue = String(params.value);
                
                // If it's in scientific notation, convert it properly
                if (npnValue.includes('e+') || npnValue.includes('E+')) {
                    const num = Number(params.value);
                    npnValue = num.toFixed(0);
                }
                
                return (
                    <Tooltip title={npnValue} arrow placement="top" enterDelay={300}>
                        <span style={{ 
                            color: 'inherit', 
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis', 
                            whiteSpace: 'nowrap', 
                            display: 'block',
                            width: '100%',
                            textAlign: 'left'
                        }}>
                            {npnValue}
                        </span>
                    </Tooltip>
                );
            },
            headerAlign: 'left'
        },
        {
            field: 'fein',
            headerName: 'FEIN',
            type: 'text',
            flex: 1.5,
            minWidth: 140,
            align: 'left',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'fein'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            renderCell: (params) => {
                const value = params.value || '';
                return (
                    <Tooltip title={value || ''} arrow placement="top" enterDelay={300}>
                        <span 
                            style={{ 
                                overflow: 'hidden', 
                                textOverflow: 'ellipsis', 
                                whiteSpace: 'nowrap', 
                                display: 'block',
                                width: '100%',
                                textAlign: 'left'
                            }}
                        >
                            {value}
                        </span>
                    </Tooltip>
                );
            },
            headerAlign: 'left'
        },
        {
            field: 'cancellationDate',
            headerName:'Cancellation Date',
            type: 'date',
            flex: 1,
            minWidth: 195,
            align: 'left',
            hideSortIcons: true,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'fein'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            },
            headerAlign: 'left',
            renderCell: (params) => {
                if (!params.value) {
                    return <span style={{ color: 'inherit', textAlign: 'left', display: 'block', width: '100%' }}>{params.value}</span>;
                }

                let cancellationDate;
                try {
                    cancellationDate = new Date(params.value);
                    if (isNaN(cancellationDate.getTime())) {
                        throw new Error('Invalid date');
                    }
                } catch (error) {
                    return <span style={{ color: 'inherit', textAlign: 'left', display: 'block', width: '100%' }}>{params.value}</span>;
                }

                return (
                    <span style={{ color: 'inherit', textAlign: 'left', display: 'block', width: '100%' }}>
                        {format(cancellationDate, 'MM/dd/yyyy')}
                    </span>
                );
            }
        },
    ];

    const RunSearch = () => {
        setLoading(true);
        setSelectedLicenseeName(filterLicensee);
        setSelectedPartner(filterClient);
        setSelectedStateId(filterState);
        
        fetchLicenseMatrixData(pageNumber,pageSize);
        setLoading(false);
    }

    const handleClickOpen = () => {
        setFormData(initialLBData);
        setOpen(true);
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!event.target.files || event.target.files.length === 0) return;
       
        const formData = new FormData();
        formData.append('file', event.target.files[0]);
        
        setLoading(true);
        apiClient(`/LicenseMatrix/ImportLicensees`, {
            method: "POST",
            headers: new Headers({
                Authorization: `Bearer ${token}`,
            }),
            body: formData,
        })
        .then((response) => {
            // Check if response has jobId (new progress tracking API)
            if (response.status && response.data?.jobId) {
                const jobId = response.data.jobId;
                startProgressTracking(jobId);
            } 
            // Fallback to old response format
            else if (response.resp == 0) {
                handleImportCompletion(response);
            } else {
                Swal.fire({
                    title: "Error",
                    text: response.message || "Failed to import licensees",
                    icon: "error",
                    confirmButtonText: "OK",
                });
                setLoading(false);
            }
        })
        .catch((error) => {
            Swal.fire({
                title: "Error",
                text: "Failed to start import",
                icon: "error",
                confirmButtonText: "OK",
            });
            setLoading(false);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
        });
    };

    const startProgressTracking = (jobId: string) => {
        isBackgroundModeRef.current = false;
        currentJobIdRef.current = jobId;
        
        // Show progress dialog
        progressSwalRef.current = Swal.fire({
            title: "Importing Licensees",
            html: `
                <div style="text-align: left;">
                    <div style="margin-bottom: 15px;">
                        <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
                            <span>Progress</span>
                            <span id="progress-percentage">0%</span>
                        </div>
                        <div style="width: 100%; background-color: #e0e0e0; border-radius: 4px; height: 25px; overflow: hidden;">
                            <div id="progress-bar" style="width: 0%; background-color: #02A4E3; height: 100%; transition: width 0.3s ease;"></div>
                        </div>
                    </div>
                    <div id="status-message" style="margin-bottom: 10px; color: #666;">Starting import...</div>
                    <div id="progress-details" style="font-size: 14px; color: #666;">
                        <div>Processed: <span id="processed-rows">0</span> / <span id="total-rows">0</span></div>
                        <div>Imported: <span id="imported-count">0</span> (<span id="new-count">0</span> new, <span id="existing-count">0</span> existing)</div>
                        <div id="invalid-count-container" style="display: none;">Invalid: <span id="invalid-count">0</span></div>
                        <div id="estimated-time" style="margin-top: 10px; font-weight: 500;"></div>
                    </div>
                </div>
            `,
            showConfirmButton: true,
            confirmButtonText: "Import in Background",
            showCancelButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonColor: "#02A4E3",
            customClass: {
                confirmButton: 'btn-radius',
                popup: 'card-radius',
            },
            didOpen: () => {
                // Start polling
                pollProgress(jobId);
            }
        }).then((result) => {
            // User clicked "Import in Background"
            if (result.isConfirmed) {
                isBackgroundModeRef.current = true;
                // Close the dialog but keep polling
                Swal.close();
                // Show a toast notification that import is running in background
                Swal.fire({
                    title: "Import Running in Background",
                    text: "You can continue working. You'll be notified when the import completes.",
                    icon: "info",
                    timer: 3000,
                    showConfirmButton: false,
                    toast: true,
                    position: 'top-end',
                });
            } else {
                // Dialog was closed without background mode - stop polling
                isPollingRef.current = false;
                if (pollIntervalRef.current) {
                    clearTimeout(pollIntervalRef.current);
                    pollIntervalRef.current = null;
                }
            }
        });
    };

    const pollProgress = (jobId: string) => {
        isPollingRef.current = true;
        
        const poll = async () => {
            // Stop polling if flag is false
            if (!isPollingRef.current) {
                return;
            }

            try {
                const response = await apiClient(`/LicenseMatrix/importProgress/${jobId}`, {
                    method: "GET",
                    headers: new Headers({
                        Authorization: `Bearer ${token}`,
                    }),
                });

                if (response.status && response.data) {
                    const progressData = response.data;
                    updateProgressUI(progressData);

                    // Check if completed or error
                    if (progressData.status === 'completed') {
                        isPollingRef.current = false;
                        if (pollIntervalRef.current) {
                            clearTimeout(pollIntervalRef.current);
                            pollIntervalRef.current = null;
                        }
                        handleImportCompletion(progressData);
                        return;
                    } else if (progressData.status === 'error') {
                        isPollingRef.current = false;
                        if (pollIntervalRef.current) {
                            clearTimeout(pollIntervalRef.current);
                            pollIntervalRef.current = null;
                        }
                        handleImportError(progressData);
                        return;
                    }
                }

                // Schedule next poll after current request completes
                // Wait 2 seconds before next request
                if (isPollingRef.current) {
                    pollIntervalRef.current = setTimeout(() => {
                        poll();
                    }, 2000);
                }
            } catch (error) {
                console.error('Error polling progress:', error);
                // Continue polling on error (might be temporary network issue)
                // Wait 2 seconds before retrying
                if (isPollingRef.current) {
                    pollIntervalRef.current = setTimeout(() => {
                        poll();
                    }, 2000);
                }
            }
        };

        // Start polling immediately
        poll();
    };

    const updateProgressUI = (progressData: any) => {
        // Only update UI if not in background mode (dialog is still open)
        if (isBackgroundModeRef.current) {
            return;
        }

        // Update progress bar
        const progressBar = document.getElementById('progress-bar');
        const progressPercentage = document.getElementById('progress-percentage');
        if (progressBar && progressPercentage) {
            const progress = progressData.progress || 0;
            progressBar.style.width = `${progress}%`;
            progressPercentage.textContent = `${progress}%`;
        }

        // Update status message
        const statusMessage = document.getElementById('status-message');
        if (statusMessage && progressData.message) {
            statusMessage.textContent = progressData.message;
        }

        // Update processed rows
        const processedRows = document.getElementById('processed-rows');
        const totalRows = document.getElementById('total-rows');
        if (processedRows) processedRows.textContent = progressData.processedRows || 0;
        if (totalRows) totalRows.textContent = progressData.totalRows || 0;

        // Update counts
        const importedCount = document.getElementById('imported-count');
        const newCount = document.getElementById('new-count');
        const existingCount = document.getElementById('existing-count');
        const invalidCount = document.getElementById('invalid-count');
        const invalidCountContainer = document.getElementById('invalid-count-container');

        if (importedCount) importedCount.textContent = progressData.importedCount || 0;
        if (newCount) newCount.textContent = progressData.newRecordCount || 0;
        if (existingCount) existingCount.textContent = progressData.existingRecordCount || 0;
        
        if (progressData.invalidCount > 0) {
            if (invalidCount) invalidCount.textContent = progressData.invalidCount || 0;
            if (invalidCountContainer) invalidCountContainer.style.display = 'block';
        }

        // Update estimated time
        const estimatedTime = document.getElementById('estimated-time');
        if (estimatedTime && progressData.estimatedTimeRemainingFormatted) {
            estimatedTime.textContent = `Estimated time remaining: ${progressData.estimatedTimeRemainingFormatted}`;
        } else if (estimatedTime) {
            estimatedTime.textContent = '';
        }
    };

    const handleImportCompletion = (response: any) => {
        // Close progress dialog if it's still open
        if (progressSwalRef.current && !isBackgroundModeRef.current) {
            Swal.close();
            progressSwalRef.current = null;
        }
        
        // Reset background mode
        isBackgroundModeRef.current = false;
        currentJobIdRef.current = null;

        // Handle both old and new response formats
        const responseData = response.data || response;
        const importedCount = responseData.importedCount || 0;
        const newRecordCount = responseData.newRecordCount || 0;
        const existingRecordCount = responseData.existingRecordCount || 0;
        const invalidCount = responseData.invalidCount || 0;
        const hasInvalidRecords = responseData.hasInvalidRecords || false;
        const invalidRecords = responseData.invalidRecords || [];
        const message = response.message || responseData.message || "Import completed";

        let title = importedCount > 0 && invalidCount > 0 ? "Warning" : importedCount > 0 ? "Success" : "Error";
        
        // Build detailed message with new and existing counts
        let messageParts: string[] = [message];
        if (newRecordCount > 0 || existingRecordCount > 0) {
            const counts = [];
            if (newRecordCount > 0) {
                counts.push(`<strong>${newRecordCount}</strong> new`);
            }
            if (existingRecordCount > 0) {
                counts.push(`<strong>${existingRecordCount}</strong> existing`);
            }
            if (counts.length > 0) {
                messageParts.push(`<br/><br/>${counts.join(', ')} record(s) imported`);
            }
        }
        if (invalidCount > 0) {
            messageParts.push(`<br/><strong>${invalidCount}</strong> invalid record(s) found`);
        }
        
        const detailedMessage = messageParts.join('');
        
        // Store invalid records if they exist
        const hasRecords = hasInvalidRecords || (invalidRecords && invalidRecords.length > 0);
        if (hasRecords && invalidRecords.length > 0) {
            setInvalidRecords(invalidRecords);
        } else {
            setInvalidRecords([]);
        }

        const swalConfig: any = {
            title: title,
            html: detailedMessage,
            icon: title == "Success" ? "success" : title == "Warning" ? "warning" : "error",
            confirmButtonText: "OK",
        };

        // Add download button if there are invalid records
        if (hasRecords && invalidRecords.length > 0) {
            swalConfig.showCancelButton = true;
            swalConfig.cancelButtonText = "Download Invalid Records";
            swalConfig.cancelButtonColor = "#02A4E3";
            swalConfig.confirmButtonColor = "#02A4E3";
            swalConfig.customClass = {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius',
            };
        }

        Swal.fire(swalConfig).then((result) => {
            if (result.dismiss === Swal.DismissReason.cancel) {
                // User clicked "Download Invalid Records"
                handleDownloadInvalidRecords(invalidRecords);
            }
            fetchLicenseMatrixData(pageNumber, pageSize);
        });

        setLoading(false);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const handleImportError = (progressData: any) => {
        // Close progress dialog if it's still open
        if (progressSwalRef.current && !isBackgroundModeRef.current) {
            Swal.close();
            progressSwalRef.current = null;
        }
        
        // Reset background mode
        isBackgroundModeRef.current = false;
        currentJobIdRef.current = null;

        const errorMessage = progressData.error || progressData.message || "An error occurred during import";
        
        Swal.fire({
            title: "Import Error",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
        });

        setLoading(false);
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
    };

    const handleDownloadInvalidRecords = async (invalidRecords: any[]) => {
        if (!invalidRecords || invalidRecords.length === 0) {
            Swal.fire({
                title: "No Invalid Records",
                text: "There are no invalid records to download.",
                icon: "info",
                confirmButtonText: "OK",
            });
            return;
        }

        try {
            // Define headers for invalid records export
            const headerRow = [
                'Row Number',
                'Error',
                'PartnersId',
                'CustomerName',
                'Licensee',
                'LicenseState',
                'LicenseNumber',
                'MainLicensee',
                'Entity',
                'NPN',
                'FEIN',
                'CancellationDate'
            ];

            const exportItems: any[] = [headerRow];

            // Add each invalid record as a row
            // Handle both formats: new format (fields directly on record) and old format (nested in data)
            invalidRecords.forEach((record) => {
                // Check if it's the old format (has data property) or new format (fields directly on record)
                const isOldFormat = record.data !== undefined && typeof record.data === 'object';
                
                let rowNumber, error, partnersId, customerName, licensee, licenseState, licenseNumber, mainLicensee, entity, npn, fein, cancellationDate;
                
                if (isOldFormat) {
                    // Old format: fields nested in data object
                    rowNumber = record.rowNumber || '';
                    error = record.error || '';
                    partnersId = record.data?.partnersId || '';
                    customerName = record.data?.customerName || '';
                    licensee = record.data?.licensee || '';
                    licenseState = record.data?.licenseState || '';
                    licenseNumber = record.data?.licenseNumber || '';
                    mainLicensee = record.data?.mainLicensee;
                    entity = record.data?.entity;
                    npn = record.data?.nPN || record.data?.npn || '';
                    fein = record.data?.fEIN || record.data?.fein || '';
                    cancellationDate = record.data?.cancellationDate;
                } else {
                    // New format: fields directly on record object (case-insensitive to handle both capitalized and lowercase)
                    rowNumber = record.RowNumber || record.rowNumber || '';
                    error = record.Error || record.error || '';
                    partnersId = record.PartnersId || record.partnersId || '';
                    customerName = record.CustomerName || record.customerName || '';
                    licensee = record.Licensee || record.licensee || '';
                    licenseState = record.LicenseState || record.licenseState || '';
                    licenseNumber = record.LicenseNumber || record.licenseNumber || '';
                    mainLicensee = record.MainLicensee !== undefined ? record.MainLicensee : (record.mainLicensee !== undefined ? record.mainLicensee : false);
                    entity = record.Entity !== undefined ? record.Entity : (record.entity !== undefined ? record.entity : false);
                    npn = record.nPN || record.npn || '';
                    fein = record.fEIN || record.fein || '';
                    cancellationDate = record.CancellationDate || record.cancellationDate;
                }

                const row = [
                    rowNumber,
                    error,
                    partnersId,
                    customerName,
                    licensee,
                    licenseState,
                    licenseNumber,
                    mainLicensee ? 'Yes' : 'No',
                    entity ? 'Yes' : 'No',
                    npn,
                    fein,
                    cancellationDate 
                        ? formatUtcToLocal(cancellationDate, 'MM-DD-YYYY') 
                        : ''
                ];
                exportItems.push(row);
            });

            const timeStamp = moment().format('YYYY.M.D');
            const excelExportName = `InvalidLicenseeRecords_${timeStamp}.xlsx`;
            
            await writeXlsxFile(exportItems, excelExportName);
            
            Swal.fire({
                title: "Download Complete",
                text: `Invalid records exported to ${excelExportName}`,
                icon: "success",
                confirmButtonText: "OK",
            });
        } catch (error) {
            console.error('Error exporting invalid records:', error);
            Swal.fire({
                title: "Export Failed",
                text: "An error occurred while exporting invalid records.",
                icon: "error",
                confirmButtonText: "OK",
            });
        }
    };

    const handleImportClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleExportClick = async () => {
        let selectedItems: LicenseesContactInformation[];

        if (selectedRowIds.length > 0) {
            selectedItems = licenseesContactArry.filter(item =>
                selectedRowIds.includes(item.partnerLincenseeInformationId)
            );
        } else {
            const res = await getLicenseMatrix(0, totalCount);
            selectedItems = res?.data?.getData_Resp || [];
        }
        onExportXlsx(selectedItems);
    }

    const fetchRequiredData = async (action: string): Promise<any[]> => {
        try {
            const response = await apiClient(action, {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                }),
            });

            return response?.data || [];
        } catch (error) {
            console.error(`Error fetching ${action}:`, error);
            return [];
        }
    };

    const setRequiredStates = async () => {
        try {
            const [partners, licenseeNames, states] = await Promise.all([
                fetchRequiredData('/Partners/getPartners'),
                fetchRequiredData('/Partners/getLicenseeNames'),
                fetchRequiredData('/States/getStates'),
            ]);

            setPartners(partners);
            setLicensees(licenseeNames);
            setStates(states);
        } catch (error) {
            console.error('Error setting required states:', error);
        }
    };

    useEffect(() => {
        setRequiredStates();
        
        // Cleanup on unmount
        return () => {
            isPollingRef.current = false;
            isBackgroundModeRef.current = false;
            if (pollIntervalRef.current) {
                clearTimeout(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
            currentJobIdRef.current = null;
        };
    }, []);

    const handleClose = () => {
        setOpen(false);
        setLoading(false);
    };

    const handleEdit = (partnerLicenseeData: LicenseesContactInformation) => {
        let a: LicenseesContactInformation = {
            partnerLincenseeInformationId: partnerLicenseeData.partnerLincenseeInformationId,
            customerName: partnerLicenseeData.customerName,
            partnersId: partnerLicenseeData.partnersId,
            postalAbbvs: partnerLicenseeData.postalAbbvs,
            licenseeName: partnerLicenseeData.licenseeName,
            pageSize : partnerLicenseeData.pageSize,
            pageNumber : partnerLicenseeData.pageNumber,
            cancellationDate: partnerLicenseeData.cancellationDate,
            entity: partnerLicenseeData.entity,
            fein: partnerLicenseeData.fein,
            licenseNumber: partnerLicenseeData.licenseNumber,
            licenseState: partnerLicenseeData.licenseState,
            licensee: partnerLicenseeData.licensee,
            mainLicensee: partnerLicenseeData.mainLicensee,
            npn: partnerLicenseeData.npn,
            title: partnerLicenseeData.title
        }
        setFormData(a);
        setOpen(true);
    };

    const handleDelete = (ids: number | GridRowId[]) => {
        const idsArray = Array.isArray(ids) ? ids : [ids];
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius',
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await apiClient(`/LicenseMatrix/deleteLicensee`, {
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        }),
                        method: "PUT",
                        body: JSON.stringify({ licenseeIds: idsArray }),
                    });
    
                    if (response) {
                        Swal.fire('Deleted!', 'Your record has been marked as deleted.', 'success').then(() => {
                            fetchLicenseMatrixData(pageNumber,pageSize);
                          });
                        setOpen(false);
                        handleClose();
                    } else {
                        Swal.fire('Error!', 'Failed to delete the record.', 'error');
                    }
                } catch (error) {
                    Swal.fire('Error!', 'An unexpected error occurred.', 'error');
                }
            }
        });
    }; 

    function ClearSearch() {
        setLoading(true);
        setSelectedStateId(0);
        setSelectedPartner(0);
        setSelectedLicenseeName('');
        setLoading(false);
    }
    
    function EditToolbar() {
        return (
            <Box sx={{ borderBottom: 1, borderColor: 'divider', p: 1 }}>
                <GridToolbarFilterButton />
            </Box>
        );
    }

    const pageSizeOptions = [10, 25, 50];
    if (totalCount > 50 && !pageSizeOptions.includes(totalCount)) {
      pageSizeOptions.push(totalCount); // Add "All" option
    }

    return (
        <>
            <div style={{ position: "fixed", top: "0", left: "0", zIndex: "9990", width: "100%" }}>
                {loading && <LinearProgress color="info" sx={{ backgroundColor: "#132D3D" }} />}
            </div>
            <input
                ref={fileInputRef}
                type="file"
                style={{ display: 'none' }}
                accept=".xls,.xlsx,.csv"
                onChange={handleFileChange}
            />
            <Box sx={{ width: "100%" }}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                        gap: 1.5,
                        px: { xs: 4, lg: 2 },
                        py: 1.5,
                        borderBottom: "1px solid #e2e8f0",
                        backgroundColor: "#fafbfc",
                        minHeight: 56,
                        // mb: 3,
                        marginLeft: { xs: '-24px', lg: '0px' },
                        marginRight: { xs: '-24px', lg: '0px' },
                    }}
                >
                    <h4 className="mb-0" style={{ fontWeight: 600, color: '#0f172a' }}>
                        License Matrix
                    </h4>
                    <Box sx={{ flex: 1, minWidth: 120 }} />
                    <Button
                        variant="contained"
                        size="medium"
                        onClick={handleClickOpen}
                        startIcon={<Add />}
                        sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            backgroundColor: "#2099d2",
                            "&:hover": { backgroundColor: "#176990" },
                        }}
                    >
                        Add New
                    </Button>
                    <Button
                        variant="outlined"
                        size="medium"
                        onClick={handleImportClick}
                        startIcon={<FileUpload />}
                        sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            borderColor: "#e2e8f0",
                            color: "#475569",
                            "&:hover": {
                                borderColor: "#2099d2",
                                backgroundColor: "#2099d214",
                                color: "#2099d2",
                            },
                        }}
                    >
                        Import
                    </Button>
                    <Button
                        variant="contained"
                        size="medium"
                        onClick={handleExportClick}
                        startIcon={<FileDownload />}
                        sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            backgroundColor: "#2099d2",
                            "&:hover": { backgroundColor: "#176990" },
                        }}
                    >
                        Export
                    </Button>
                    
                    {selectedRowIds.length > 0 && (
                        <Button
                            variant="outlined"
                            size="medium"
                            onClick={() => handleDelete(selectedRowIds)}
                            sx={{
                                textTransform: "none",
                                fontWeight: 600,
                                borderColor: "#e2e8f0",
                                color: "#475569",
                                "&:hover": {
                                    borderColor: "#2099d2",
                                    backgroundColor: "#2099d214",
                                    color: "#2099d2",
                                },
                            }}
                        >
                            Remove
                        </Button>
                    )}
                </Box>
                <Box
                    sx={{
                        width: "100%",
                        py: 2,
                        px: 2,
                        backgroundColor: "#ffffff",
                        borderBottom: "1px solid #e2e8f0",
                    }}
                >
                    <Grid container spacing={2} className="filter-grid" display="flex">
                            <Grid item xl={2} lg={4} sm={6} xs={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        sx={{
                                            marginTop: "-4px !important",
                                            "& .MuiAutocomplete-input": { padding: "0px 4px 0px 5px !important" },
                                        }}
                                        options={licensees}
                                        getOptionLabel={(option) => option.licenseeName}
                                        onChange={(event, value) => {
                                            const id = value?.licenseeId ?? 0;
                                            id === 0 && setSelectedLicenseeName('');
                                            setFilterLicensee(value?.licenseeName ?? '');
                                        }}
                                        value={licensees.find(item => item.licenseeName === selectedLicenseeName)}
                                        renderInput={(params) => (
                                            <TextField
                                                sx={{
                                                    ".MuiFormLabel-root.Mui-focused": {
                                                        color: (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? "#000" : "#cccccc !important",
                                                    },
                                                    '& .MuiInputBase-root': { marginTop: '5px !important' },
                                                    '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                                                    '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                                    '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                                                }}
                                                {...params}
                                                label="Licensee"
                                                InputLabelProps={{ ...params.InputLabelProps, shrink: (selectedLicenseeName !== '' || (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0)) ? true : false }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xl={2} lg={4} sm={6} xs={12}>
                                <FormControl size="small" sx={{ minWidth: 250, marginRight: '20px' }} fullWidth>
                                    <Autocomplete
                                        sx={{
                                            marginTop: "-4px !important",
                                            "& .MuiAutocomplete-input": { padding: "0px 4px 0px 5px !important" },
                                        }}
                                        options={States}
                                        getOptionLabel={(option) => option.stateName}
                                        onChange={(event, value) => {
                                            const id = value?.stateId ?? 0;
                                            id === 0 && setSelectedStateId(0);
                                            setFilterState(id);
                                        }}
                                        value={States.find(item => item.stateId === Number(selectedStateId))}
                                        renderInput={(params) => (
                                            <TextField
                                                sx={{
                                                    ".MuiFormLabel-root.Mui-focused": {
                                                        color: (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? "#000" : "#cccccc !important",
                                                    },
                                                    '& .MuiInputBase-root': { marginTop: '5px !important' },
                                                    '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                                                    '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                                    '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                                                }}
                                                {...params}
                                                label="State"
                                                InputLabelProps={{ ...params.InputLabelProps, shrink: (selectedStateId !== 0 || (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0)) ? true : false }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xl={2} lg={4} sm={6} xs={12}>
                                <FormControl size="small" sx={{ minWidth: 250, marginRight: '20px' }} fullWidth>
                                    <Autocomplete
                                        sx={{
                                            marginTop: "-4px !important",
                                            "& .MuiAutocomplete-input": { padding: "0px 4px 0px 5px !important" },
                                        }}
                                        options={Partners}
                                        getOptionLabel={(option) => option.customerName}
                                        onChange={(event, value) => {
                                            const id = value?.partnersId ?? 0;
                                            id === 0 && setSelectedPartner(0);
                                            setFilterClient(id);
                                        }}
                                        value={Partners.find(item => item.partnersId === Number(selectedPartner))}
                                        renderInput={(params) => (
                                            <TextField
                                                sx={{
                                                    ".MuiFormLabel-root.Mui-focused": {
                                                        color: (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0) ? "#000" : "#cccccc !important",
                                                    },
                                                    '& .MuiInputBase-root': { marginTop: '5px !important' },
                                                    '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                                                    '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                                    '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                                                }}
                                                {...params}
                                                label="Client"
                                                InputLabelProps={{ ...params.InputLabelProps, shrink: (selectedPartner !== 0 || (typeof params.inputProps.value === "string" && params.inputProps.value.length > 0)) ? true : false }}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm="auto">
                                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                                    <Button
                                        variant="contained"
                                        size="medium"
                                        onClick={() => RunSearch()}
                                        startIcon={<Search />}
                                        sx={{
                                            textTransform: "none",
                                            fontWeight: 600,
                                            backgroundColor: "#2099d2",
                                            "&:hover": { backgroundColor: "#176990" },
                                        }}
                                    >
                                        Search
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        onClick={() => {
                                            ClearSearch();
                                        }}
                                        startIcon={<Close />}
                                        sx={{
                                            textTransform: "none",
                                            fontWeight: 600,
                                            borderColor: "#e2e8f0",
                                            color: "#475569",
                                            "&:hover": { borderColor: "#2099d2", color: "#2099d2" },
                                        }}
                                    >
                                        Clear
                                    </Button>
                                </Box>
                            </Grid>
                    </Grid>
                </Box>
            </Box>
            <Box
                sx={{
                    // flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
                    border: '1px solid #e2e8f0',
                    backgroundColor: '#ffffff',
                    height: 'calc(100vh - 300px)',
                }}
            >
                <DataGridPro
                    getRowId={(r) => (r.partnerLincenseeInformationId)}
                    rows={licenseesContactArry}
                    columns={columns}
                    rowCount={totalCount}
                    pageSize={pageSize}
                    pagination
                    paginationMode="server"
                    onPageChange={(newPage: number) => setPageNumber(newPage + 1)}
                    rowsPerPageOptions={[10, 25, 50]}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    filterMode="server"
                    onFilterModelChange={(newFilterModel: any) => setFilterModel(newFilterModel)}
                    sortingMode="server"
                    sortingOrder={['asc', 'desc']}
                    onSortModelChange={(newSortModel: any) => setSortModel(newSortModel)}
                    checkboxSelection={true}
                    onSelectionModelChange={(newRowSelectionModel) => {setSelectedRowIds(newRowSelectionModel)}}
                    components={{
                        Toolbar: EditToolbar,
                    }}
                    disableColumnResize={false}
                    // autoHeight={false}
                    sx={{
                        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                        border: 'none',
                        fontSize: '14px',
                        color: '#475569',
                        backgroundColor: '#ffffff',
                        width: '100%',
                        '& .MuiDataGridPro-columnHeaderTitle': {
                            whiteSpace: 'normal',
                            lineHeight: 1.35,
                            fontWeight: 600,
                            fontSize: '12px',
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase',
                            color: '#64748b',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#f8fafc',
                            borderBottom: '2px solid #e2e8f0',
                            borderTop: '2px solid #e2e8f0',
                            minHeight: '52px !important',
                            maxHeight: '52px !important',
                        },
                        '& .MuiDataGrid-columnHeader': {
                            '&:focus, &:focus-within': { outline: 'none' },
                        },
                        '& .MuiDataGrid-row': {
                            transition: 'background-color 0.15s ease',
                            '&:nth-of-type(even)': {
                                backgroundColor: '#fafbfc',
                            },
                            '&:hover': {
                                backgroundColor: '#f1f5f9 !important',
                            },
                            '&.Mui-selected': {
                                backgroundColor: '#ebf5fa !important',
                                '&:hover': {
                                    backgroundColor: '#dbeef7 !important',
                                },
                            },
                        },
                        '& .MuiDataGrid-cell': {
                            borderBottom: '1px solid #f1f5f9',
                            fontSize: '14px',
                            color: '#334155',
                            overflow: 'visible',
                            whiteSpace: 'normal',
                            lineHeight: 'normal',
                            wordWrap: 'break-word',
                            textOverflow: 'clip',
                            padding: '8px 16px',
                            textAlign: 'left',
                            justifyContent: 'start',
                            '&:focus': { outline: 'none' },
                        },
                        '& .MuiDataGrid-cellContent': {
                            overflow: 'visible',
                            textOverflow: 'ellipsis',
                        },
                        '& .MuiDataGrid-root': {
                            width: '100%',
                            height: '100%',
                            minHeight: 0,
                            display: 'flex',
                            flexDirection: 'column',
                        },
                        '& .MuiDataGrid-main': {
                            width: '100%',
                            flex: 1,
                            minHeight: 0,
                            overflowX: 'auto',
                            border: 'none',
                        },
                        '& .MuiDataGrid-virtualScroller': {
                            overflowX: 'auto !important',
                            border: 'none',
                            minHeight: 0,
                        },
                        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                            marginBottom: '0px !important',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            borderTop: '1px solid #e2e8f0',
                            backgroundColor: '#f8fafc',
                            minHeight: 56,
                        },
                        '& .MuiTablePagination-root': {
                            color: '#64748b',
                            fontSize: '13px',
                        },
                        '& .MuiTablePagination-select': {
                            fontSize: '13px',
                            borderRadius: '6px',
                            border: '1px solid #e2e8f0',
                        },
                        '& .MuiIconButton-root': {
                            color: '#64748b',
                            '&:hover': {
                                backgroundColor: '#f1f5f9',
                                color: '#475569',
                            },
                        },
                        '& .MuiCheckbox-root': {
                            color: '#94a3b8',
                            '&.Mui-checked': {
                                color: '#2099d2',
                            },
                        },
                    }}
                />
            </Box>
            <AddEditLicenseContact
                handleClose={handleClose}
                Open={Open}
                licenseesContactInformation={Formdata}
                handleSubmit={handleClose}
                initValues={initialLBData}
                fetchLicenseMatrixData={fetchLicenseMatrixData}
                pageNumber={pageNumber}
                pageSize={pageSize}
                States={States}
                Partners={Partners}
            />
        </>
    )
}
